import { ReactNode, useLayoutEffect } from 'react';
import { UnifiedTheme, UnifiedThemeProvider } from '@backstage/theme';

/**
 * Keeps the KERN tokens in sync with the theme selected in Backstage.
 *
 * KERN switches colours via `data-kern-theme` on the root element, while Backstage sets
 * `data-theme-mode` for Backstage UI. Both must agree, otherwise light and dark surfaces
 * get mixed.
 */
export const KernThemeProvider = (props: {
  theme: UnifiedTheme;
  variant: 'light' | 'dark';
  children: ReactNode;
}) => {
  const { theme, variant, children } = props;

  useLayoutEffect(() => {
    const root = document.documentElement;
    const previous = root.getAttribute('data-kern-theme');
    root.setAttribute('data-kern-theme', variant);
    return () => {
      if (previous) {
        root.setAttribute('data-kern-theme', previous);
      } else {
        root.removeAttribute('data-kern-theme');
      }
    };
  }, [variant]);

  return <UnifiedThemeProvider theme={theme}>{children}</UnifiedThemeProvider>;
};
